import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KbaseDocuments from './KbaseDocuments';
import KbaseFeedback from './KbaseFeedback';

function KbaseWorkspace({ kbaseId: kbaseIdOverride = '', embedded = false, toolbarStart = null }) {
    const { kbaseId: routeKbaseId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const kbaseId = kbaseIdOverride || routeKbaseId;
    const routeTab = location.pathname.endsWith('/feedback') ? 'feedback' : 'documents';
    const tab = routeTab;
    const [documentCount, setDocumentCount] = useState(0);
    const [feedbackCount, setFeedbackCount] = useState(0);

    const handleTabChange = (_, value) => {
        if (embedded) {
            const basePath = location.pathname.endsWith('/feedback')
                ? location.pathname.slice(0, -'/feedback'.length)
                : location.pathname.replace(/\/$/, '');
            const nextPath = value === 'feedback' ? `${basePath}/feedback` : basePath;
            navigate(`${nextPath}${location.search}`);
            return;
        }
        const suffix = value === 'feedback' ? 'feedback' : 'documents';
        navigate(`/kbases/${encodeURIComponent(kbaseId)}/${suffix}${location.search}`);
    };

    return <Box sx={{ p: embedded ? 0 : 2 }}>
        <Tabs
            value={tab}
            onChange={handleTabChange}
            sx={{
                mb: 3,
                borderBottom: 1,
                borderColor: 'divider',
                '& .MuiTabs-indicator': { bgcolor: '#f36b21', height: 3 },
                '& .MuiTab-root': { minWidth: 0, px: 1, mr: 3, fontWeight: 700, textTransform: 'none' },
                '& .Mui-selected': { color: '#f36b21 !important' },
            }}
        >
            <Tab
                value="documents"
                label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    {t('kbaseFeedback.tabs.documents', 'Documents')}
                    {documentCount > 0 && <Box component="span" sx={{ bgcolor: '#fff0e7', color: '#f36b21', borderRadius: 10, px: 0.8, py: 0.15, fontSize: '0.75rem' }}>{documentCount}</Box>}
                </Box>}
            />
            <Tab
                value="feedback"
                label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    {t('kbaseFeedback.tabs.improvements', 'Improvement candidates')}
                    {feedbackCount > 0 && <Box component="span" sx={{ bgcolor: '#fff0e7', color: '#f36b21', borderRadius: 10, px: 0.8, py: 0.15, fontSize: '0.75rem' }}>{feedbackCount}</Box>}
                </Box>}
            />
        </Tabs>
        {tab === 'documents' ? <KbaseDocuments embedded kbaseId={kbaseId} toolbarStart={toolbarStart} onCountChange={setDocumentCount} /> : <KbaseFeedback kbaseId={kbaseId} onCountChange={setFeedbackCount} />}
    </Box>;
}

export default KbaseWorkspace;
